/**
 * Admin API client — cookie-based auth (httpOnly).
 *
 * The backend sets an httpOnly `ih_admin_token` cookie on /api/admin/login
 * that browsers automatically attach to same-site requests when
 * `withCredentials: true`. No token is ever exposed to JavaScript.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({
    baseURL: API,
    withCredentials: true,
});

adminApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            if (!window.location.pathname.startsWith("/admin/login")) {
                window.location.assign("/admin/login");
            }
        }
        return Promise.reject(err);
    },
);

/**
 * Probe /api/admin/me to determine authenticated state. Returns the admin
 * profile on success, null on 401. Always await this — auth state can only
 * be determined by asking the server (no localStorage token to peek at).
 */
export const fetchAdminMe = async () => {
    try {
        const res = await adminApi.get("/admin/me");
        return res.data;
    } catch (_) {
        return null;
    }
};

export const adminLogout = async () => {
    try {
        await adminApi.post("/admin/logout");
    } catch (_) {
        // ignore — cookie may already be cleared server-side
    }
};

export default adminApi;
